module.exports = {
    doublegame: {
        background: "res/doublegame_background.jpg",
        
        currentWinLabel:{
            position:{x:266, y:112},
            font:"doublegame_win_font",
            align:"center"
        },

        nextWinLabel:{
            position:{x:743, y:112},
            font:"doublegame_next_win_font",
            align:"center"
        },

        selectLabel:{
            redPosition:{x:246, y:540},
            blackPosition:{x:788, y:540},
            image:"select.png"
        },

        playerWinsLabel:{
            position:{x:512, y:100},
            image:"player_wins.png"
        },

        playerLoseLabel:{
            position:{x:512, y:100},
            image:"player_lose.png"
        },

        centralCard: {
            position:{x:512, y:310},
            neutralShirt:"neutral_shirt.png",
            redShirt:"red_shirt.png",
            blackShirt:"black_shirt.png"
        },

        suits:{
            diamonds:"diamonds.png",
            hearts:"hearts.png",
            spades:"spades.png",
            clubs:"clubs.png"
        },

        history:{
            length:5,
            position:{x:555, y:168},
            cardOffset:90,
            cardScale:0.45
        },

        redButton:{
            position:{x:246, y:353},
            state:{
                normal:"button_red.png",
                over:"button_red.png",
                pressed:"button_red.png",
                disabled:"button_red.png"
            }
        },

        blackButton:{
            position:{x:788, y:353},
            state:{
                normal:"button_black.png",
                over:"button_black.png",
                pressed:"button_black.png",
                disabled:"button_black.png"
            }
        },

        collectButton:{
            position:{x:872, y:615}
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./cfg/doublegame-config.js
// module id = 32
// module chunks = 0